import React from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { AuthProvider, useAuth } from "@/admin/AuthContext";
import AdminLayout from "@/admin/Layout";
import Login from "@/admin/pages/Login";
import Dashboard from "@/admin/pages/Dashboard";
import Leads from "@/admin/pages/Leads";
import LeadDetail from "@/admin/pages/LeadDetail";
import Clients from "@/admin/pages/Clients";
import ClientDetail from "@/admin/pages/ClientDetail";
import ProjectsAll from "@/admin/pages/ProjectsAll";
import ProjectDetail from "@/admin/pages/ProjectDetail";

// Public site is rendered as static HTML in /public/index.html.
// React only takes over the page when we're under /admin/*.
const PublicPlaceholder = () => null;

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0a0a14] text-[#9c95a8]">
        Loading…
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicPlaceholder />} />
          <Route path="/thank-you.html" element={<PublicPlaceholder />} />
          <Route path="/admin/login" element={<Login />} />
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="leads" element={<Leads />} />
            <Route path="leads/:id" element={<LeadDetail />} />
            <Route path="clients" element={<Clients />} />
            <Route path="clients/:id" element={<ClientDetail />} />
            <Route path="projects" element={<ProjectsAll />} />
            <Route path="projects/:id" element={<ProjectDetail />} />
          </Route>
          <Route path="*" element={<PublicPlaceholder />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
